import { api } from "./client";
import type {
  KnowledgeBaseEntry,
  KnowledgeBaseListResponse,
  KnowledgeBaseCreate,
  KnowledgeBaseUpdate,
} from "@/types";

export async function listKnowledge(params: {
  category?: string;
  search?: string;
  show_archived?: boolean;
} = {}): Promise<KnowledgeBaseListResponse> {
  const query = new URLSearchParams();
  if (params.category && params.category !== "all") query.set("category", params.category);
  if (params.search) query.set("search", params.search);
  if (params.show_archived) query.set("show_archived", "true");
  const suffix = query.toString() ? `?${query.toString()}` : "";
  const { data } = await api.get<KnowledgeBaseListResponse>(`/knowledge${suffix}`);
  return data;
}

export async function getKnowledge(id: number): Promise<KnowledgeBaseEntry> {
  const { data } = await api.get<KnowledgeBaseEntry>(`/knowledge/${id}`);
  return data;
}

export async function createKnowledge(payload: KnowledgeBaseCreate): Promise<KnowledgeBaseEntry> {
  const { data } = await api.post<KnowledgeBaseEntry>("/knowledge", payload);
  return data;
}

export async function updateKnowledge(
  id: number,
  payload: KnowledgeBaseUpdate,
): Promise<KnowledgeBaseEntry> {
  const { data } = await api.put<KnowledgeBaseEntry>(`/knowledge/${id}`, payload);
  return data;
}

export async function archiveKnowledge(id: number): Promise<KnowledgeBaseEntry> {
  const { data } = await api.post<KnowledgeBaseEntry>(`/knowledge/${id}/archive`);
  return data;
}

export async function unarchiveKnowledge(id: number): Promise<KnowledgeBaseEntry> {
  const { data } = await api.post<KnowledgeBaseEntry>(`/knowledge/${id}/unarchive`);
  return data;
}

export async function deleteKnowledge(id: number): Promise<void> {
  await api.delete(`/knowledge/${id}`);
}
